import CustomButton from "@/components/custom-button/custom-button";
import { WalletLink, SuccessMessage } from "../style-component";
import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Spin, Typography } from "antd";

interface RedeemButtonStatesProps {
    isLoading: boolean;
    disabled: boolean;
    showSuccess: boolean;
    error: string | null;
    onRedeem: () => void;
}

const RedeemButtonStates: React.FC<RedeemButtonStatesProps> = ({
    isLoading,
    disabled,
    error,
    showSuccess,
    onRedeem
}) => {

    if (isLoading) {
        return (
            <Spin style={{ margin: '10px 0px'}} indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} size="small" />
        )
    }

    if (showSuccess) {
        return (
            <>
            <SuccessMessage>
                ¡Redimido exitosamente! <CheckCircleOutlined />
            </SuccessMessage>
            <WalletLink to="/wallet">
                ¡Ya lo tienes! Ver en mi wallet
            </WalletLink>
            </>
        );
    }

    return (
        <>
        <Typography.Text type="danger">
            {error}
        </Typography.Text>
        <CustomButton 
            onClick={onRedeem} 
            disabled={disabled} 
        >
            Redimir
        </CustomButton>
        </>
    );
};

export default RedeemButtonStates;